export const mapearRespuesta = (status, data)=>{
    let objetoRespuesta = {};
    objetoRespuesta.status = status;
    objetoRespuesta.data = data;
    return objetoRespuesta;
}

export const mapearError = (error)=>{
    let objetoError = {};
    let tipoError = '';
    if (error.response) {
        const { data, status } = error.response;
        objetoError.status = status;
        objetoError.data = data;
        objetoError.tipo = 'RESPONSE';
        tipoError = 'Error';
    } else if (error.request) {
        objetoError.error = error.request;
        objetoError.tipo = 'REQUEST';
        tipoError = 'Error';
    } else {
        objetoError.error = error.message;
        objetoError.tipo = 'EXCEPTION';
        tipoError = 'Exception';
    }
    return {objetoError,tipoError};
}